import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Page",
    component: () => import("../views/Page.vue"),
    children:[
      {
        path: "/",
        name: "",
        component: () => import("../views/Landing/index.vue"),
      },
    ]
  },
  {
    path: "/purchase/index",
    name: "Purchase",
    component: () => import("../views/Purchase/index.vue"),
  },
  {
    path: "/main/deletion",
    component: () => import("../views/deleteaccount/index.vue"), // 将组件移到父路由
    children: [
      {
        path: "",
        redirect: "regulation1", // 重定向到同级的 regulation1 路由
      },
      {
        path: "regulation1",
        name: "regulation1",
        component: () => import("../views/deleteaccount/regulation1.vue"),
      },
      {
        path: "regulation2",
        name: "regulation2",
        component: () => import("../views/deleteaccount/regulation2.vue"),
      },
      {
        path: "chooseGame",
        name: "chooseGame",
        component: () => import("../views/deleteaccount/chooseGame.vue"),
      },
      {
        path: "chooseLogin",
        name: "chooseLogin",
        component: () => import("../views/deleteaccount/chooseLogin.vue"),
      },
      {
        path: "login",
        name: "deleteaccountLogin",
        component: () => import("../views/deleteaccount/login.vue"),
      },
      {
        path: "isDeleteAccount",
        name: "isDeleteAccount",
        component: () => import("../views/deleteaccount/isDeleteAccount.vue"),
      },
      {
        path: "tip",
        name: "tip",
        component: () => import("../views/deleteaccount/tip.vue"),
      },
    ]
  },
  {
    path: "/atmResult",
    name: "AtmResult",
    component: () => import("../views/AtmResult/index.vue"),
  },
  {
    path: "/purchaseResult",
    name: "PurchaseResult",
    component: () => import("../views/PurchaseResult/index.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/Info/index.vue"),
    children:[
      {
        path: "/",
        name: "",
        component: () => import("../views/Login/index.vue"),
      },
      {
        path: "/Consume",
        name: "Consume",
        component: () => import("../views/consume/index.vue"),
      },
      {
        path: "/login/autoLogin",
        name: "autoLogin",
        component: () => import("../views/autoLogin/index.vue"),
      },
    ]
  },
  {
    path: "/shop",
    name: "Shop",
    component: () => import("../views/Shop/index.vue"),
  },
  {
    path: "/guestBind",
    name: "GuestBind",
    component: () => import("../views/guestBind/index.vue"),
  },
];

const originalPush = VueRouter.prototype.push
 
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  mode: "history",
  // base: process.env.BASE_URL,
  routes,
});

export default router;
